// extracted by mini-css-extract-plugin
module.exports = {"scrollable_menu":"GameCustomText_scrollable_menu__38vpi"};